import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "relative mb-6 overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }
const _hoisted_3 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_4 = { class: "rounded-2xl bg-white/10 px-4 py-3 text-sm text-blue-50" }
const _hoisted_5 = { class: "mt-1 text-xl font-bold" }
const _hoisted_6 = { class: "mb-6 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-6" }
const _hoisted_7 = { class: "flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between" }
const _hoisted_8 = { class: "max-w-3xl" }
const _hoisted_9 = { class: "mt-1 text-xl font-bold text-slate-900" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2 text-sm leading-6 text-slate-600"
}
const _hoisted_11 = {
  key: 1,
  class: "mt-3 list-disc space-y-1 pl-5 text-sm leading-6 text-slate-600"
}
const _hoisted_12 = {
  key: 0,
  class: "mt-5 border-t border-slate-100 pt-4"
}
const _hoisted_13 = { class: "grid gap-3 sm:grid-cols-2 xl:grid-cols-3" }
const _hoisted_14 = { class: "text-xs font-semibold uppercase tracking-wide text-slate-500" }
const _hoisted_15 = { class: "mt-2 flex flex-wrap gap-2" }
const _hoisted_16 = { class: "mb-6 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" }
const _hoisted_17 = { class: "grid gap-4 lg:grid-cols-[1fr_260px]" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = { class: "grid gap-6 lg:grid-cols-[310px_1fr]" }
const _hoisted_20 = { class: "h-fit rounded-2xl border border-slate-100 bg-white shadow-sm lg:sticky lg:top-6" }
const _hoisted_21 = { class: "flex items-center justify-between border-b border-slate-100 px-4 py-3" }
const _hoisted_22 = {
  key: 0,
  class: "overflow-hidden divide-y divide-slate-100"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "block text-sm font-semibold" }
const _hoisted_25 = {
  key: 1,
  class: "m-4 rounded-lg border border-dashed border-slate-300 bg-slate-50 p-5 text-center"
}
const _hoisted_26 = {
  key: 0,
  class: "overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm"
}
const _hoisted_27 = { class: "border-b border-slate-100 bg-white px-6 py-6 sm:px-8" }
const _hoisted_28 = { class: "mb-4 flex flex-wrap items-center gap-2" }
const _hoisted_29 = { class: "rounded-full bg-[#003793]/10 px-3 py-1 text-sm font-semibold text-[#003793]" }
const _hoisted_30 = { class: "text-2xl font-bold text-slate-900 sm:text-3xl" }
const _hoisted_31 = { class: "mt-3 max-w-4xl text-sm leading-7 text-slate-600" }
const _hoisted_32 = { class: "divide-y divide-slate-100 px-6 sm:px-8" }
const _hoisted_33 = { class: "py-6" }
const _hoisted_34 = { class: "divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-100" }
const _hoisted_35 = { class: "flex gap-4" }
const _hoisted_36 = { class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#003793] text-sm font-bold text-white" }
const _hoisted_37 = { class: "font-bold text-slate-900" }
const _hoisted_38 = { class: "mt-1 text-sm leading-7 text-slate-600" }
const _hoisted_39 = {
  key: 1,
  class: "rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm"
}

import { computed, defineComponent, h, ref, watch, type CSSProperties } from "vue";
import { useRoute, useRouter } from "vue-router";
import AppSelect from '@/components/input/AppSelect.vue';
import { usePermissions } from "@/hooks/usePermissions";
import { canAccess } from "@/utils/permissions";
import { NAV_GROUPS, navGroupsForRole } from "@/utils/navigation";
import { MANUAL_ENTRIES, ROLE_GUIDES, type ManualEntry, type ManualItem } from "@/utils/userManual";

type GuideItem = ManualItem;


export default /*@__PURE__*/_defineComponent({
  __name: 'UserManualView',
  setup(__props) {

const guideIconPaths: Record<string, string[]> = {
  "Kolom yang Ditampilkan": [
    "M4.5 6.75h15",
    "M4.5 12h15",
    "M4.5 17.25h15",
    "M8.25 4.5v15",
    "M15.75 4.5v15",
  ],
  "Filter dan Pencarian": [
    "m21 21-4.35-4.35",
    "M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z",
    "M5.25 7.5h10.5",
    "M7.5 10.5h6",
  ],
  "Field Form": [
    "M6.75 3.75h7.5L18 7.5v12.75H6.75V3.75Z",
    "M14.25 3.75V7.5H18",
    "M9 11.25h6",
    "M9 14.25h6",
    "M9 17.25h3",
  ],
  "Tombol dan Aksi": [
    "M6 12h12",
    "m13.5 6 6 6-6 6",
    "M4.5 6.75h4.125",
    "M4.5 17.25h4.125",
  ],
  "Nilai Status / Opsi": [
    "M9 12.75 11.25 15 15.75 9",
    "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  ],
};

const GuideSection = defineComponent({
  name: "GuideSection",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    items: { type: Array as () => GuideItem[], required: true },
  },
  setup(props) {
    return () =>
      h("section", { class: "py-6" }, [
        h("div", { class: "mb-4 flex items-center gap-3" }, [
          h("div", { class: "flex h-9 w-9 items-center justify-center rounded-lg bg-[#003793]/10 text-[#003793]" }, [
            h(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8",
              },
              (guideIconPaths[props.title] || [
                "M12 6.75h.008v.008H12V6.75Z",
                "M11.25 10.5H12v6.75h.75",
                "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
              ]).map((path) =>
                h("path", {
                  d: path,
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                })
              )
            ),
          ]),
          h("div", {}, [
            h("h3", { class: "text-lg font-bold text-slate-900" }, props.title),
            h("p", { class: "text-sm text-slate-500" }, props.description),
          ]),
        ]),
        h(
          "div",
          { class: "divide-y divide-slate-200 overflow-hidden rounded-lg border-2 border-slate-200" },
          props.items.map((item) =>
            h("div", { class: "grid gap-2 bg-white p-4 md:grid-cols-[180px_1fr] md:gap-0" }, [
              h("p", { class: "text-sm font-bold text-slate-900 md:border-r md:border-slate-200 md:pr-4" }, item.title),
              h("p", { class: "text-sm leading-6 text-slate-600 md:pl-4" }, item.description),
            ])
          )
        ),
      ]);
  },
});


const router = useRouter();
const route = useRoute();
const { selectedRole, selectedRoleId } = usePermissions();
const searchKeyword = ref("");
const selectedCategory = ref("");
const selectedFeatureId = ref(typeof route.query.topic === "string" ? route.query.topic : "");

const roleGuide = computed(() => (selectedRoleId.value ? ROLE_GUIDES[selectedRoleId.value] : undefined));
const selectedRoleName = computed<string>(() => selectedRole.value?.name || "");
const roleMenus = computed(() => navGroupsForRole(selectedRoleId.value));

// Hak akses topik = hak akses route-nya (meta.roles di router), sehingga
// manual selalu sejalan dengan menu yang benar-benar bisa dibuka.
const entryRoles = (item: ManualEntry) => {
  if (item.route) return router.resolve(item.route).meta.roles;
  return item.roles;
};

// Urutan topik: umum dulu, lalu mengikuti urutan menu sidebar.
const NAV_ORDER = NAV_GROUPS.flatMap((group) => group.items.map((item) => item.to));
const entryOrder = (item: ManualEntry) => {
  if (!item.route) return -1;
  const index = NAV_ORDER.findIndex((to) => item.route === to || item.route?.startsWith(`${to}/`));
  return index === -1 ? NAV_ORDER.length : index;
};

const accessibleDocumentation = computed(() => {
  return MANUAL_ENTRIES
    .filter((item) => canAccess(entryRoles(item), selectedRoleId.value))
    .map((item, index) => ({ item, index }))
    .sort((a, b) => entryOrder(a.item) - entryOrder(b.item) || a.index - b.index)
    .map(({ item }) => item);
});

const categories = computed(() => {
  return Array.from(new Set(accessibleDocumentation.value.map((item) => item.category)));
});

const categoryOptions = computed(() => [
  { value: '', label: 'Semua kategori' },
  ...categories.value.map((c) => ({ value: c, label: c })),
]);

const filteredDocumentation = computed(() => {
  const keyword = searchKeyword.value.trim().toLowerCase();

  return accessibleDocumentation.value.filter((item) => {
    const matchCategory = selectedCategory.value
      ? item.category === selectedCategory.value
      : true;

    const searchableText = [
      item.title,
      item.category,
      item.summary,
      ...item.tableColumns.map((item) => `${item.title} ${item.description}`),
      ...item.filters.map((item) => `${item.title} ${item.description}`),
      ...item.formFields.map((item) => `${item.title} ${item.description}`),
      ...item.buttons.map((item) => `${item.title} ${item.description}`),
      ...item.statusValues.map((item) => `${item.title} ${item.description}`),
      ...item.steps.map((step) => `${step.title} ${step.description}`),
    ]
      .join(" ")
      .toLowerCase();

    const matchKeyword = keyword ? searchableText.includes(keyword) : true;

    return matchCategory && matchKeyword;
  });
});

const selectedFeature = computed(() => {
  return filteredDocumentation.value.find((item) => item.id === selectedFeatureId.value);
});

watch(filteredDocumentation, (items) => {
  if (!items.length) {
    selectedFeatureId.value = "";
    return;
  }

  const stillExists = items.some((item) => item.id === selectedFeatureId.value);

  if (!stillExists) {
    selectedFeatureId.value = items[0].id;
  }
}, { immediate: true });

watch(categories, (items) => {
  if (selectedCategory.value && !items.includes(selectedCategory.value)) {
    selectedCategory.value = "";
  }
});

const selectFeature = (featureId: string) => {
  selectedFeatureId.value = featureId;
};

const guideNavButtonStyle = (featureId: string): CSSProperties => {
  if (selectedFeatureId.value !== featureId) {
    return {};
  }

  return {
    boxShadow: "inset 6px 0 0 #ffffff, inset 0 0 0 1px rgba(255,255,255,0.12)",
  };
};

const resetFilter = () => {
  searchKeyword.value = "";
  selectedCategory.value = "";
  selectedFeatureId.value = accessibleDocumentation.value[0]?.id || "";
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, " Manual Penggunaan "),
          _createElementVNode("p", { class: "mt-2 max-w-3xl text-sm leading-relaxed text-blue-100" }, " Panduan dashboard admin IOM ITB untuk peran Anda. Isi manual menyesuaikan peran aktif: hanya menu yang bisa Anda buka yang ditampilkan. ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm font-medium text-blue-100" }, "Topik untuk peran ini", -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(accessibleDocumentation.value.length) + " Topik", 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Peran Anda", -1)),
          _createElementVNode("h2", _hoisted_9, _toDisplayString(roleGuide.value?.label || selectedRoleName.value || 'Belum memilih peran'), 1),
          (roleGuide.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(roleGuide.value.summary), 1))
            : _createCommentVNode("", true),
          (roleGuide.value)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleGuide.value.tasks, (task) => {
                  return (_openBlock(), _createElementBlock("li", { key: task }, _toDisplayString(task), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_link, {
          to: "/select",
          class: "inline-flex shrink-0 items-center justify-center rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-[#003793] transition hover:bg-[#003793]/5"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Ganti Peran ", -1)
          ]))]),
          _: 1
        })
      ]),
      (roleMenus.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mb-3 text-sm font-semibold text-slate-900" }, "Menu yang bisa Anda buka", -1)),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleMenus.value, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group.label,
                  class: "rounded-lg border border-slate-100 bg-slate-50 p-3"
                }, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(group.label), 1),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: item.to,
                        to: item.to,
                        class: "rounded-full bg-white px-3 py-1 text-sm font-medium text-slate-700 ring-1 ring-slate-200 transition hover:text-[#003793] hover:ring-[#003793]/30"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "search",
            class: "mb-2 block text-sm font-semibold text-slate-900"
          }, " Cari di manual ", -1)),
          _createElementVNode("div", _hoisted_18, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-slate-400" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.5"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                })
              ])
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
              type: "text",
              placeholder: "Cari: donasi, ongkir, opsi produk, broadcast, status...",
              class: "h-12 w-full rounded-lg border border-slate-200 bg-white py-0 pl-11 pr-4 text-sm text-slate-700 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-[#8c8c94]/20"
            }, null, 512), [
              [_vModelText, searchKeyword.value]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "mb-2 block text-sm font-semibold text-slate-900" }, " Kategori ", -1)),
          _createVNode(AppSelect, {
            modelValue: selectedCategory.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCategory).value = $event)),
            options: categoryOptions.value,
            "button-class": "h-12 py-0"
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("aside", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-base font-semibold text-slate-700" }, " Daftar Topik ", -1)),
          (searchKeyword.value || selectedCategory.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "text-xs font-semibold text-[#003793] hover:underline",
                onClick: resetFilter
              }, " Reset "))
            : _createCommentVNode("", true)
        ]),
        (filteredDocumentation.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDocumentation.value, (feature) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: feature.id,
                  type: "button",
                  class: _normalizeClass(["block w-full rounded-none px-5 py-3 text-left transition", 
                selectedFeatureId.value === feature.id
                  ? 'bg-[#003793] text-white'
                  : 'bg-white text-slate-700 hover:bg-slate-50 hover:shadow-[inset_4px_0_0_rgba(0,55,147,0.28)]'
              ]),
                  style: _normalizeStyle(guideNavButtonStyle(feature.id)),
                  onClick: ($event: any) => (selectFeature(feature.id))
                }, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(feature.title), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["mt-1 block text-xs", selectedFeatureId.value === feature.id ? 'text-white/75' : 'text-slate-500'])
                  }, _toDisplayString(feature.category), 3)
                ], 14, _hoisted_23))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("p", { class: "text-sm font-semibold text-slate-900" }, "Tidak ada hasil", -1),
              _createElementVNode("p", { class: "mt-1 text-xs leading-5 text-slate-500" }, " Coba ubah kata kunci atau kategori. ", -1)
            ]))]))
      ]),
      _createElementVNode("main", null, [
        (selectedFeature.value)
          ? (_openBlock(), _createElementBlock("article", _hoisted_26, [
              _createElementVNode("header", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(selectedFeature.value.category), 1),
                  (selectedFeature.value.route)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: selectedFeature.value.route,
                        class: "inline-flex items-center gap-1 rounded-full border border-slate-200 px-3 py-1 text-sm font-semibold text-slate-600 transition hover:border-[#003793]/30 hover:bg-[#003793]/5 hover:text-[#003793]"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" Buka fitur ", -1),
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-3.5 w-3.5",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "1.8"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M13.5 4.5H19.5M19.5 4.5V10.5M19.5 4.5L10.5 13.5"
                            }),
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M19.5 13.5V18.75A.75.75 0 0 1 18.75 19.5H5.25A.75.75 0 0 1 4.5 18.75V5.25A.75.75 0 0 1 5.25 4.5H10.5"
                            })
                          ], -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h2", _hoisted_30, _toDisplayString(selectedFeature.value.title), 1),
                _createElementVNode("p", _hoisted_31, _toDisplayString(selectedFeature.value.summary), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                (selectedFeature.value.tableColumns.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 0,
                      title: "Kolom yang Ditampilkan",
                      description: "Kolom atau informasi utama yang dapat dilihat admin pada halaman ini.",
                      items: selectedFeature.value.tableColumns
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                (selectedFeature.value.filters.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 1,
                      title: "Filter dan Pencarian",
                      description: "Kontrol yang digunakan untuk menyaring atau mencari data.",
                      items: selectedFeature.value.filters
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                (selectedFeature.value.formFields.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 2,
                      title: "Field Form",
                      description: "Field yang perlu diisi saat membuat atau mengubah data.",
                      items: selectedFeature.value.formFields
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(GuideSection), {
                  title: "Tombol dan Aksi",
                  description: "Tombol yang tersedia serta fungsi masing-masing tombol.",
                  items: selectedFeature.value.buttons
                }, null, 8, ["items"]),
                (selectedFeature.value.statusValues.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 3,
                      title: "Nilai Status / Opsi",
                      description: "Nilai pilihan atau status yang digunakan pada fitur ini.",
                      items: selectedFeature.value.statusValues
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_33, [
                  _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"mb-4 flex items-center gap-3\"><div class=\"flex h-9 w-9 items-center justify-center rounded-lg bg-[#003793]/10 text-[#003793]\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"1.7\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.25 6.75H21M8.25 12H21M8.25 17.25H21M3.75 6.75H3.758V6.758H3.75V6.75ZM3.75 12H3.758V12.008H3.75V12ZM3.75 17.25H3.758V17.258H3.75V17.25Z\"></path></svg></div><div><h3 class=\"text-lg font-bold text-slate-900\">Cara Menggunakan</h3><p class=\"text-sm text-slate-500\">Urutan penggunaan fitur dari awal sampai selesai.</p></div></div>", 1)),
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFeature.value.steps, (step, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${selectedFeature.value.id}-${index}`,
                        class: "bg-white p-4"
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, _toDisplayString(index + 1), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", _hoisted_37, _toDisplayString(step.title), 1),
                            _createElementVNode("p", _hoisted_38, _toDisplayString(step.description), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("h2", { class: "text-xl font-bold text-slate-900" }, "Topik tidak ditemukan", -1),
              _createElementVNode("p", { class: "mt-2 text-sm text-slate-600" }, " Ubah kata kunci pencarian atau pilih kategori lain. ", -1)
            ]))]))
      ])
    ])
  ]))
}
}

})